import { useReducedMotion } from "framer-motion";
import MeshBlobs from "./MeshBlobs";
import GridPattern from "./GridPattern";
import ParticleCanvas from "./ParticleCanvas";

export default function Background() {
  const reduce = useReducedMotion();

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <GridPattern />
      <MeshBlobs />
      {!reduce && <ParticleCanvas />}
    </div>
  );
}